<template>
  <section>
    <b-button
      class="btn trs-collapse-button d-flex justify-items-between mb-5 mr-md-5"
      variant="primary"
      v-dynamic-content="{ rawText: text.collapseBtnText }"
      v-b-toggle="mode"
    ></b-button>
    <b-collapse :id="mode" accordion="order-info" :ref="mode" :visible="visible">
      <div class="content">
        <p v-for="(paragraph, index) of text.paragraphs" :key="index">
          {{ paragraph }}
        </p>
        <form @submit.prevent="sendRequest" novalidate>
          <small>{{ text.smallText }}</small>
          <b-form-textarea
            class="mb-5"
            id="textarea"
            v-model="trsCustomerInput"
            :placeholder="text.placeholder"
            :state="$v.trsCustomerInput.$dirty ? !$v.trsCustomerInput.$invalid : null"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <b-form-invalid-feedback>
            <div v-if="!$v.trsCustomerInput.requiredValidation">
              {{ content.trs_form_error_required }}
            </div>
          </b-form-invalid-feedback>
          <div class="trs-form-footer">
            <b-button
              type="submit"
              variant="secondary"
              v-dynamic-content="{ rawText: text.ctaBtnText }"
            ></b-button>
          </div>
        </form>
      </div>
    </b-collapse>
  </section>
</template>

<script>
import FormMixin from '@/components/main/form/FormMixin'

export default {
  props: ['id', 'mode', 'text', 'visible'],
  name: 'TrsCollapseItem',
  mixins: [FormMixin],
  data() {
    return {
      trsCustomerInput: null,
    }
  },
  methods: {
    sendRequest(e) {
      e.preventDefault()
      this.$v.$touch()

      if (this.$v.trsCustomerInput.$invalid) {
        return
      }

      this.$store
        .dispatch('putActivity', {
          activity: this.mode,
          quoteId: this.id,
          trsCustomerInput: this.trsCustomerInput,
        })
        .then(() => {
          this.$store.commit('TRS_FORM_SENT_MODE', this.mode)
        })
    },
  },
  mounted() {
    const refEl = this.$refs.TRS_CONFIRM_PROPOSAL
    if (refEl) {
      const position = this.getRealOffset(refEl.$el, true)
      this.$store.commit('SET_TRS_COLLAPSE_POS', position)
    }
  },
  destroyed() {
    this.$store.commit('SET_TRS_COLLAPSE_POS', 0)
  },
}
</script>
